const objectAddress = {
  id: 0,
  name: "",
  address_line_1: "",
  address_line_2: "",
  street_number: "",
  city: "",
  region: "",
  postcode: "",
  country: "",
  lat: 0,
  lng: 0,
  notes: "",
  is_primary: false,
};

export default Object(objectAddress)